import { Link } from "react-router-dom";
import { services } from "../data/services";

function FacebookIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M13.5 21v-7h2.3l.5-3h-2.8V9.1c0-.8.4-1.6 1.7-1.6H16V5c-.4-.1-1.2-.2-2.2-.2-2.2 0-3.8 1.4-3.8 4V11H7.5v3H10v7h3.5Z" />
    </svg>
  );
}

function XIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.657l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z" />
    </svg>
  );
}

function LinkedInIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.34V8.98h3.42v1.57h.05c.47-.9 1.64-1.85 3.37-1.85 3.61 0 4.27 2.37 4.27 5.46v6.29ZM5.32 7.41a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12Zm1.78 13.04H3.54V8.98H7.1v11.47Z" />
    </svg>
  );
}

function Footer() {
  return (
    <footer className="bg-white border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-blue-600 flex items-center justify-center">
              <span className="text-white text-sm font-semibold">N</span>
            </div>
            <span className="text-xl font-light tracking-tight">
              <span className="text-slate-950">Nucleon</span><span className="font-semibold text-blue-600">soft</span>
            </span>
          </Link>

          <p className="mt-6 text-slate-500 font-light leading-7 max-w-md">
            A digital agency helping businesses create professional websites, brands, marketing assets, and
            online solutions.
          </p>
        </div>

        <div>
          <h4 className="font-light text-slate-900 mb-4">Services</h4>
          <div className="space-y-3 text-slate-500 font-light text-sm">
            {services.map((service) => (
              <p key={service.id}>
                <Link to={service.path} className="hover:text-blue-600 transition">
                  {service.name}
                </Link>
              </p>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-light text-slate-900 mb-4">Contact</h4>
          <div className="space-y-3 text-slate-500 font-light text-sm">
            <p>hello@nucleonsoft.com</p>
            <p>
              <Link to="/california-digital-agency" className="hover:text-blue-600 transition">
                California Digital Agency
              </Link>
            </p>
            <p className="flex items-center gap-2">
              <a
                href="https://www.facebook.com/profile.php?id=61591520040431"
                target="_blank"
                rel="noreferrer"
                aria-label="Nucleonsoft Facebook"
                className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 bg-slate-50 text-slate-600 transition hover:border-blue-200 hover:bg-blue-50 hover:text-blue-600"
              >
                <FacebookIcon className="h-4 w-4" />
              </a>
              <a
                href="https://x.com/NucleonSoft"
                target="_blank"
                rel="noreferrer"
                aria-label="Nucleonsoft on X"
                className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 bg-slate-50 text-slate-600 transition hover:border-blue-200 hover:bg-blue-50 hover:text-blue-600"
              >
                <XIcon className="h-3.5 w-3.5" />
              </a>
              <a
                href="https://www.linkedin.com/company/nucleonsoft/?viewAsMember=true"
                target="_blank"
                rel="noreferrer"
                aria-label="Nucleonsoft on LinkedIn"
                className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 bg-slate-50 text-slate-600 transition hover:border-blue-200 hover:bg-blue-50 hover:text-blue-600"
              >
                <LinkedInIcon className="h-4 w-4" />
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-slate-100">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row justify-between gap-4 text-sm text-slate-400 font-light">
          <p>© 2026 Nucleonsoft. All rights reserved.</p>
          <p>Designed for modern business growth.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
